import { Icon } from "@repo/ui/components/icon";

import { MoraGrid } from "~/components/mora-grid";

export const PendingComponent = () => {
  return (
    <div className="relative flex h-full w-full items-center justify-center overflow-hidden">
      <MoraGrid className="pointer-events-none absolute inset-0 size-full text-foreground/60" />
      <Icon.Logo name="mora" className="relative size-12 animate-pulse" />
    </div>
  );
};
